import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  private messages: any[] = [];

  constructor() {
  }

  getMessages(): any[] {
    return this.messages;
  }

  close(message: any): void {
    message.closing = true;
    setTimeout(() => {
      const i = this.messages.indexOf(message);
      this.messages.splice(i, 1);
    }, 1000);
  }

  success(message: string, duration: number = 2500): void {
    const msg = {
      message,
      button: null,
      type: 'success',
      closing: false
    };

    this.messages.push(msg);

    setTimeout(() => {
      this.close(msg);
    }, duration);
  }

  warning(message: string, duration: number = 0): void {
    const msg = {
      message,
      button: 'close',
      type: 'warning',
      closing: false
    };

    this.messages.push(msg);

    if (duration) {
      setTimeout(() => {
        this.close(msg);
      }, duration);
    }
  }

  error(message: string, data: any = null, duration: number = 0): void {
    const msg = {
      message,
      data,
      button: 'close',
      type: 'error',
      closing: false
    };

    this.messages.push(msg);

    if (duration) {
      setTimeout(() => {
        this.close(msg);
      }, duration);
    }
  }
}
